import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import Space from "../../general/antd/space";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ColumnsType } from "antd/es/table";
import { IContactUs } from "../../../models/contactus/response";
import ContactUsContext from "../../../context/contactus/context";
import ViewBtn from "../../general/table-components/actions/view-btn";
import {  getContactUsStatus, getContactUsStatusColors } from "../../../models/contactus/enum";
import { Tag } from "antd";
import SeenBtn from "../../general/table-components/actions/seen-btn";

interface IProps { }

const ContactUsTable: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(ContactUsContext);

  const columns: ColumnsType<IContactUs> = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 80,
    },
    {
      title: t("name"),
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: t("contact_way"),
      dataIndex: "contact_way",
      align: "center",
      key: "contact_way",
    },
    {
      title: t("status"),
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => {
        return <Tag color={getContactUsStatusColors(Number(status))}>{t(getContactUsStatus(Number(status)))}</Tag>;
      }
    },
    {
      title: t("actions"),
      dataIndex: "",
      key: "x",
      fixed: "right",
      width: 180,
      align: "center",
      render: (_, record) => (
        <Space>
          <ViewBtn
            onClick={async () => {
              navigate(`details/${record?.id}`);
            }}
          />
          <SeenBtn
            onClick={async () => {
              await actions.updateContactUs(record.id, { status: 2 });
              eventManager.emit(EVENT_SUCCESS);
            }}
            disabled={loading.includes("update") || record.status==2}
          />
          
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteContactUs(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
         
        </Space>
      ),
    },
  ];

  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);
  let tableFiltersProps = {};

  useEffect(() => {
    if (sorts.length > 0) {
      actions.setQuery({
        ...query,
        orders: sorts,
      });
    }
  }, [sorts]);

  return (
    <Table<IContactUs>
      rowKey="id"
      showPagination={true}
      columns={columns}
      dataSource={list?.data ?? []}
      loading={loading.includes("list")}
      size="small"
      total={list?.total}
      pageSize={query.perPage}
      page={query.page}
      onPaginationChange={(page, pageSize) => {
        actions.setQuery({
          ...query,
          page,
          perPage: pageSize,
        });
      }}
      onChange={(_, tableFilters, tableSorters) => {
        tableOnChange(
          tableFilters,
          tableSorters,
          tableFiltersProps,
          setSorts,
          setStaticFilters
        );
      }}
    />
  );
};

export default ContactUsTable;
